app.service('wcProductCardSubscriptionServices', function () {
	return {
		init() {
		}
	};
});